<template>
  <div class="bi-bottom-container">
    <div v-show="isShow" class="bi-bottom-box">
      <div class="bi-bottom">
        <img
          class="bi-bottom-icon"
          src="../assets/images/fir-class/bottom-icon.png"
          alt="baiinfo"
        />
        <div class="bi-sider"></div>
        <div class="bi-bottom-content">
          <div class="line-content">
            Copyright@2007 - 现在 BAIINFO.COM Inc. All Rights Reserved. 百川盈孚
            版权所有
          </div>
          <div class="line-content">
            <span class="pr-4">
              地址：北京市东城区东直门外大街39号院2号楼航空服务楼5层501A
            </span>
            <span class="pr-4"> 邮编：100028</span>
          </div>
          <div class="line-content">
            <span class="pr-4"> 联系人：熊文国 </span>
            <span class="pr-4">
              电话：010-59795659 
            </span>
            <span class="pr-4"> 手机：18618300427 </span>
            <span class="pr-4"> Email：xwg@baiinfo.com </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-tip">
      <img class="bottom-guohui" src="../assets/images/guohui.png" alt="国徽">
      <div>
        京公网安备11010102006027号
      </div>
      <div>京B2-20191023</div>
      <div>京ICP备19003235号</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    isShow: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.bi-bottom-container {
  background-color: #313139;
  width: 100%;
  font-size: 12px;
  font-family: "Noto Sans SC";
  .pr-4{
    padding-right: 1rem;
  }
  .bi-bottom-box {
    width: 100%;
    color: #ffffff;
    margin: auto;
    .bi-bottom {
      // @apply flex flex-wrap justify-center items-center py-8 px-4;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      padding: 2rem 1rem;
      .bi-bottom-icon {
        width: 109px;
        height: 44px;
      }
      .bi-sider {
        display: none;
        width: 1px;
        height: 5rem;
        margin: 0 40px;

        // @apply bg-gradient-to-b from-transparent via-white to-transparent hidden;
        background: linear-gradient(
          to bottom,
          transparent,
          #ffffff,
          transparent
        );
      }

      .bi-bottom-content {
        opacity: 0.7;
        // @apply flex flex-col justify-around text-sm leading-8 py-2;
        display: flex;
        flex-flow: column;
        justify-content: space-around;
        line-height: 2rem;
        padding: 0.5rem 0;
        .line-content {
          // @apply flex flex-wrap;
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
}
.bottom-tip{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  color: white;
  background-color: #000000;
  padding: 0 1rem;
  .bottom-guohui{
    width: 1rem;
    height: 1rem;
    object-fit: contain;
  }
  div{
    padding: .5rem .5rem;
  }
}
@media (min-width: 768px) {
  .bottom-tip{
    justify-content: center;
  }
  .bi-bottom-container {
    .bi-bottom-box {
      .bi-bottom {
        height: 160px;
        display: flex ;
        flex-wrap: nowrap;
        .bi-bottom-icon{
          width: 109px;
          height: 44px;
        }
        .bi-sider{

          display: block;

        }
      }
    }
  }
}

// @screen md {
//   .bi-bottom-container {
//     .bi-bottom-box {
//       .bi-bottom {
//         height: 160px;
//         @apply flex flex-nowrap;
//         .bi-bottom-icon {
//           width: 109px;
//           height: 44px;
//         }
//         .bi-sider {
//           margin: 0 20px;
//           @apply block bg-gradient-to-b from-transparent via-white to-transparent;
//         }

//         .bi-bottom-content {
//           @apply flex flex-col justify-around text-sm leading-8;
//         }
//       }
//     }
//   }
// }

// @screen xl {
//   .bi-bottom-container {
//     .bi-bottom-box {
//       width: 1200px;

//       .bi-bottom {
//         .bi-sider {
//           margin: 0 40px;
//           @apply block;
//         }
//       }
//     }
//   }
// }
</style>